// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__5KK4Q","amount":"Amount_amount__3LU-7","tip":"Amount_tip__3ik0N","tipHeader":"Amount_tipHeader__2brkf","tipsWrap":"Amount_tipsWrap__a580J"};